export interface SidebarConfig {
  width: number;
}

export const sidebarConfig: SidebarConfig = {
  width: 300,
};
